<template>
  <el-dialog
    title="选择公司"
    :visible.sync="showDialog"
    append-to-body
    @close="dialogClose"
    :show-close="showClose"
    :close-on-click-modal="false"
    width="40%"
    center
    >
    <div style="min-height: 300px;" v-loading="loading">
			<div v-if="relatedEntList.length > 5" style="padding: 0 27px 10px 10px;">
				<el-input v-model="queryEntName" placeholder="企业名称" clearable size="large" />
			</div>

      <div :style="relatedEntList.length > 5? 'overflow-y: scroll; height: 400px;' : ''" >
				<el-card :class="['ent-card', (selectedEnt && item.entCode == selectedEnt.entCode) ? (selectedEnt.enabled == '1' ? 'active' : 'isDisabled'):'default']" v-for="item in showEntList" :key="item.entCode" @click.native="selectEnt(item)" @dblclick.native="switchEnt(item)">
				  <div class="ent-name">
				    {{ item.entName }}({{ item.entBriefName }})
				    <i class="el-icon-circle-close disabled" style="color: #fff;float: right;" v-if="item.enabled=='0' || item.entEnabled == '0'"> 已停用</i>
				    <i class="el-icon-circle-check checked" style="color: #fff;float: right;" v-else-if="currentEntCode == item.entCode"> 已登录</i>
				  </div>
				  <div class="ent-log">
				    <span>登录角色：
				      <span>{{ item.roleName }}</span>
				    </span>
				    <span v-if="item.lastLoginTime">{{ currentEntCode == item.entCode ? '' : '上次' }}登录时间：{{ item.lastLoginTime }}</span>
				  </div>
				</el-card>
			</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="text" :loading="submitLoading" @click="cancel">取 消</el-button>
      <el-button type="primary" :disabled="!selectedEnt || selectedEnt.enabled == '0' || selectedEnt.entEnabled == '0' || currentEntCode == selectedEnt.entCode" :loading="submitLoading" @click="switchEnt(null)">{{ confirmButtonText }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getToken, setToken } from "@/utils/auth";
import { entChange, getRelationshipList } from '@/api/login'
export default {
  props: {
    showClose: {
      type: Boolean,
      default: true
    },
    confirmButtonText: {
      type: String,
      default: '确认登录'
    }
  },
  data() {
    return {
      // 弹窗
      showDialog: false,
      // 当前企业code
      currentEntCode: null,
      // 选择的企业信息
      selectedEnt: null,
      // loading
      loading: false,
      submitLoading: false,
      // 企业列表
      relatedEntList: [],
			// 企业名称
			queryEntName: '',
      // token
      token: ''
    }
  },
	computed: {
		// 显示的企业列表
		showEntList() {
			return this.relatedEntList.filter(item => item.entName.includes(this.queryEntName))
		}
	},
	watch: {
		// 监听搜索改变
		 queryEntName: function (newVal) {
			// 如果显示列表中不存在已选中的公司，则清空已选
			if(this.selectedEnt && this.selectedEnt.entCode) {
				if(!this.showEntList.some(item => item.entCode == this.selectedEnt.entCode)) {
					this.selectedEnt = null
				}
			}
		}
	},
  methods: {
    // 打开弹窗
    openDialog(relatedEntList = [], token = null) {
      this.relatedEntList = relatedEntList
      this.token = token
			this.queryEntName = ''
      this.showDialog = true
      this.currentEntCode = null
      this.selectedEnt = null
      this.loading = false
      this.submitLoading = false

      // 默认选择已登录企业
      if (this.relatedEntList && this.relatedEntList.length) {
        if (getToken()) {
          this.currentEntCode = this.$store.getters.user.entCode
          this.selectedEnt = this.relatedEntList.find(item => item.entCode == this.currentEntCode)
        }
        // else {
        //   this.selectedEnt = this.relatedEntList[0]
        // }
      }

      // 如果是已登录状态
      // if (getToken() && this.$store.getters.user && this.$store.getters.user.entCode) {
      //   this.currentEntCode = this.$store.getters.user.entCode
      //   // 获取关联企业列表
      //   this.loading = true
      //   // this.$store.dispatch('GetInfo').then(res => {
      //   //   this.loading = false
      //   //   this.relatedEntList = this.$store.getters.user.relationshipList
      //   //   this.selectedEnt = this.relatedEntList.find(item => {
      //   //     return item.entCode == this.currentEntCode
      //   //   })
      //   // })
      //   getRelationshipList({ username: this.$store.getters.user.username }).then(res => {
      //     this.loading = false
      //     this.relatedEntList = res || []
      //     this.relatedEntList = this.$store.getters.user.relatedEntList
      //     this.selectedEnt = this.relatedEntList.find(item => {
      //       return item.entCode == this.currentEntCode
      //     })
      //   })
      // }
    },
    // 设置关联企业列表
    setRelatedEntList(data) {
      this.relatedEntList = data
    },
    // 选择企业
    selectEnt(item) {
      this.selectedEnt = item
    },
    // 切换企业
    switchEnt(item = null) {
      if (item) {
        this.selectEnt(item)
      }
      // 选择了已登录企业
      if (this.selectedEnt.entCode == this.currentEntCode) {
        return this.$message.warning('当前登录账号为所选公司')
      }
      if (this.selectedEnt.enabled == '0' || this.selectedEnt.entEnabled == '0') {
        return this.$message.warning('该公司账号已停用')
      }

      // 如果是登录时选择企业，则先设置token
      if (this.token) {
        setToken(this.token)
        this.$store.commit('SET_TOKEN', this.token)
      }

      this.submitLoading = true
      // 调取切换接口
      entChange(this.selectedEnt).then(res => {
        this.submitLoading = false
        this.showDialog = false
        // 当系统处于登录状态，关闭所有标签页，并刷新页面
        if (getToken()) {
          return this.$store.dispatch('tagsView/delAllViews').then(() => {
            // 如果从官网过来
            if (window.sessionStorage.getItem('website_redirect')) {
              const website_redirect = window.sessionStorage.getItem('website_redirect')
              window.sessionStorage.removeItem('website_redirect')
              location.href = `${website_redirect}?tk=${getToken()}`
            }
            else {
              location.replace('/');
            }
            // this.$router.replace({
            //   path: this.$route.query.redirect || '/'
            // })
          })
        }
        this.$emit('switch')
      })
    },
    // 取消
    cancel() {
      this.showDialog = false
      this.$emit('cancel')
    },
    dialogClose() {},
  }
}
</script>

<style lang="scss" scoped>
.ent-card + .ent-card {
	margin-top: 10px;
	margin-bottom: 10px;
}

.ent-card {
  margin-left: 10px;
	margin-right: 10px;
  user-select: none;
  .ent-name {
    font-weight: bold;
    font-size: 18px;
  }
  .ent-log {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    font-size: 13px;
  }
}
.default {
  color: #000;
  background-color: #fff;
  cursor: pointer;
  .checked {
    color: #67C23A !important;
  }
  .disabled {
    color: #F56C6C !important;
  }
}
.active {
  color: #fff;
  background-color: #409EFF;
  border: 1px solid #409EFF;
}
.isDisabled {
  color: #fff;
  background-color: #DCDFE6;
  border: 1px solid #DCDFE6;
}
.default:hover {
  border: 1px solid #409EFF;
  color: #409EFF;
}
</style>
